export enum DynamicVariableType {
  CLIENT_NAME = 'ClientName',
  CLIENT_LAST_NAME = 'ClientLastName',
}

export interface DynamicVariableValues {
  firstName?: string;
  lastName?: string;
}
